/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { HealthService } from './services/health.service';
import { AnalyticsService } from './services/analytics.service';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { GameTrackerService } from './services/game-tracker.service';
import { GameTrackerPublicService } from './services/game-tracker-public.service';
import { ScoutingService } from './services/scouting.service';
import { ExternalScoutingService } from './services/external-scouting.service';
import { CustomEliteConfigurationService } from './services/custom-elite-configuration.service';
import { IntegrationsService } from './services/integrations.service';
import { ViastoriaService } from './services/viastoria.service';
import { BillingService } from './services/billing.service';
import { SuperadminService } from './services/superadmin.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    HealthService,
    AnalyticsService,
    AuthService,
    UserService,
    GameTrackerService,
    GameTrackerPublicService,
    ScoutingService,
    ExternalScoutingService,
    CustomEliteConfigurationService,
    IntegrationsService,
    ViastoriaService,
    BillingService,
    SuperadminService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
